export default __webpack_public_path__ + "static/media/panel6.4f083d56.jpg";